import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import type { AccessibleClient } from '../types/auth';
import { BRAND, LOGO } from '../lib/url';

export default function SelectContextPage() {
  const { user, selectContext, isSuperAdmin } = useAuth();
  const navigate = useNavigate();

  if (user?.active_client) {
    navigate('/');
    return null;
  }

  const handleSelectContext = async (clientId: string) => {
    await selectContext(clientId);
    navigate('/');
  };

  const clients: AccessibleClient[] = user?.available_clients ?? [];

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center py-12 px-4">
      <div className="w-full max-w-2xl space-y-8">
        <div className="flex flex-col items-center">
          <img src={LOGO} alt={BRAND} className="w-full max-w-xs" />
          <p className="mt-4 text-center text-lg text-gray-700 font-medium">
            Bonjour, {user?.full_name || user?.username}
          </p>
        </div>

        <div className="bg-white shadow rounded-lg p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-6 text-center">
            Sélectionnez votre contexte de travail
          </h2>

          {clients.length === 0 && isSuperAdmin() ? (
            <p className="text-center text-gray-500 text-sm">
              Aucun client disponible. En tant que superadmin, vous avez un accès cross-tenant.
            </p>
          ) : (
            <div className="grid gap-4 sm:grid-cols-2">
              {clients.map((client) => (
                <div
                  key={client.id}
                  className="border border-gray-200 rounded-lg p-4 hover:border-primary hover:shadow-sm transition-all"
                >
                  <div className="mb-3">
                    <p className="text-lg font-semibold text-gray-900">{client.name}</p>
                    <p className="text-xs text-gray-400 mt-0.5">{client.slug}</p>
                    <p className="text-sm text-gray-600 mt-1">
                      Rôle: {client.role_in_client}
                      {isSuperAdmin() && (
                        <span className="ml-2 text-xs text-indigo-600">(superadmin — accès cross-tenant)</span>
                      )}
                    </p>
                  </div>
                  <button
                    onClick={() => handleSelectContext(client.id)}
                    className="w-full py-2 px-4 bg-primary text-white text-sm font-medium rounded-md hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 transition-colors"
                  >
                    Continuer
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
